import styled from 'styled-components';

export const ModalOverlay = styled.div`
  max-width: 480px;
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;

  .close-btn {
    position: absolute;
    right: 15px;
    top: 15px;
    width: 36px;
    height: 36px;
    font-size: 1.8em;
    cursor: pointer;
    color: #333;
    background: white;
    border: none;
    border-radius: 50%;
    padding: 0;
    z-index: 10;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  }
`;

export const ModalTotal = styled.div`
  width: 80%;
  max-width: 350px;
`;

export const ModalContent = styled.div`
  background: white;
  border-radius: 20px;
  overflow: hidden;
  position: relative;

  .img {
    width: 100%;
    display: block;
  }
`;

export const Button = styled.div`
  text-align: center;

  .button {
    background-color: #1FBC70;
    border: 2px solid #1FBC70;
    border-radius: 20px;
    margin-left: auto;
    margin-right: auto;
    width: 85%;
    height: 50px;
    margin-top: 20px;
    margin-bottom: 15px;
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
    color: white;

    &:hover {
      background-color: white;
      color: #1FBC70;
    }
  }
`;

export const ModalInfo = styled.div`
  margin-top: 20px;
  margin-left: 5%;
  padding-bottom: 10px;
  text-align: left;

  .title {
    font-size: 1.2em;
    font-weight: bold;
    text-align: left;
  }

  .location {
    font-size: 1em;
    margin-top: 5px;
    text-align: left;
  }

  .time {
    margin-top: 15px;
    color: #FFBE55;
    text-align: left;
  }
`;

export const ModalHeader = styled.div`
  background-color: transparent;
  text-align: center;
  margin-bottom: 30px;
  color: white;
  font-size: 1.1em;
  line-height: 1.5;
`;

export const GreenText = styled.span`
  color: #1FBC70;
  font-weight: bold;
`;
